module.exports = __webpack_public_path__ + "static/img/device-mockup01.f31bdde.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/device-mockup01.png
// module id = 5/2e
// module chunks = 0